module.exports = __webpack_public_path__ + "img/import_csv.6aa94eda.svg";